export default class AdditionalEquipment {
  constructor({
    quantity = 0,
    handsetID = 10022,
    cost = 0,
    comment = '',
    lineTotal = 0,
    gst = 10,
    freight = 10,
    service = null,
  } = {}) {
    this.quantity = quantity;
    this.handsetID = handsetID;
    this.cost = cost;
    this.comment = comment;
    this.lineTotal = lineTotal;
    this.gst = gst;
    this.freight = freight;
    this.service = service;
  }
}

// export function createAdditionalEquipment(data) {
//   return Object.freeze(new AdditionalEquipment(data));
// }
